import { useAccount, Fingerprint } from "modules/common";
import { useMemo } from "react";
import { UserAccounts } from "services";

export interface FingerprintDisplayClasses {
    containerClassName?: string;
    labelClassName?: string;
    textClassName?: string;
}

export interface IFingerprintDisplay extends FingerprintDisplayClasses {
    item?: Fingerprint;
    value: "created" | "lastUpdated";
}
export const FingerprintDisplay = (props: IFingerprintDisplay) => {
    const { item, ...jsxProps } = props;
    const { value } = jsxProps;

    const userId = useMemo(() => {
        return value === "created" ? item?.createdBy : item?.lastUpdatedBy;
    }, [item, value]);

    const time = useMemo(() => {
        return value === "created" ? item?.created : item?.lastUpdated;
    }, [item, value]);

    const { data: user, isLoading, isError } = useAccount(userId);

    if (!item || isLoading || isError) return null;

    return <FingerprintJsx user={user} time={time} {...jsxProps} />;
};

export interface IFingerprintJsxProps extends Omit<IFingerprintDisplay, "item"> {
    user?: UserAccounts;
    time?: string;
}
export const FingerprintJsx = ({
    user,
    time,
    value,
    containerClassName,
    labelClassName,
    textClassName,
}: IFingerprintJsxProps) => {
    return (
        <div className={`fingerprint ${containerClassName ?? ""}`}>
            <span className={`fingerprint-label ${labelClassName ?? ""}`}>
                {value === "created" ? "Kreirao" : "Zadnju izmjenu napravio"}
            </span>
            <span className={`fingerprint-text ${textClassName ?? ""}`}>
                {!user ? "Nepoznati korisnik" : `${user.firstName} ${user.lastName}`}
            </span>
            <span className={`fingerprint-text ${textClassName ?? ""}`}>
                {time && new Date(time).toLocaleString("HR-hr")}
            </span>
        </div>
    );
};
